import { Badge, Col, Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { Form } from "shared/ui";
import "./UploadToOCR.styles.css";
import { useState } from "react";
import FilesWithErrors from "../FilesWithErrors/FilesWithErrors";

function UploadToOCR({
  control,
  disabled = false,
  uploadedFiles = [],
  setValue,
  validations,
  setIsUploadingFilesToOCR,
}) {
  const [filesWithErrors, setFilesWithErrors] = useState([]);
  const { t } = useTranslation("OCR");
  return (
    <Row className="ocr-container rounded-3 p-4">
      <span className="mb-2">
        <Badge bg="primary">New</Badge>
        <Badge bg="warning" className="ms-1">
          BETA
        </Badge>
      </span>
      <h4 className="mb-5">{t("header")}</h4>
      <Col md="4">
        <p className="small">{t("subheader")}</p>
        <small>
          <Trans i18nKey="attachments_requirements" ns="OCR">
            Chosen files with Doc Buddy must be:
            <ul>
              <li>one page only;</li>
              <li>one receipt/invoice only;</li>
              <li>vertical; facing the top up;</li>
              <li>clear and readable (no folds etc.)</li>
            </ul>
          </Trans>
        </small>
      </Col>
      <Col md={8}>
        <Form.FilesInput
          withOCR
          control={control}
          setValue={setValue}
          label={t("attachments_label")}
          name="ocr_attachments"
          disabled={disabled}
          uploadedFiles={uploadedFiles}
          maxSize={validations?.ocr_attachments?.max_allowed_file_size_in_bytes}
          max={validations?.ocr_attachments?.attachments_count_rules.data?.max}
          min={validations?.ocr_attachments?.attachments_count_rules.data?.min}
          acceptedExtensions={
            validations?.ocr_attachments?.attachments_allowed_file_types.data
          }
          setExternalUploadingState={setIsUploadingFilesToOCR}
          setFilesWithErrors={setFilesWithErrors}
        />
        {filesWithErrors.length > 0 && (
          <FilesWithErrors files={filesWithErrors} />
        )}
      </Col>
    </Row>
  );
}

export default UploadToOCR;
